import api from '../../utils/api';
import constants from '../constants';
import ListingActions from './ListingActions';

const RatingAndReviewActions = {
  fetchListingByAliasEncoded({ aliasEncoded = '', components = '' } = {}) {
    if (aliasEncoded) {
      return function (dispatch) {
        let apiArgs = {
          alias: aliasEncoded,
          components: components || constants.FETCH_ALL_COMPONENTS,
          type: 'unit',
          unit: '',
          validate: false,
        };
        return dispatch(api.listing.fetchByAlias(apiArgs))
          .then((apiResponse) => {
            if (apiResponse.success && apiResponse.data) {
              return apiResponse.data;
            } else {
              throw {
                listingNotFound: true,
              };
            }
          })
          .then((processedBuilding) => {
            return dispatch(ListingActions.validateAliasEncoded(processedBuilding, aliasEncoded));
          })
          .then((buildingAndListing) => {
            dispatch(RatingAndReviewActions.setListing(buildingAndListing.listing));
            return buildingAndListing;
          });
      };
    }
  },
  submitReview({ reviews, providerListingId } = {}) {
    return (dispatch) => {
      return dispatch(
        api.review.submit({
          reviews,
          providerListingId,
        }),
      );
    };
  },
  setListing(listing) {
    return (dispatch) => {
      return dispatch({
        type: constants.SET_RATING_AND_REVIEW_LISTING,
        payload: listing,
      });
    };
  },
  editPropertyRating(rating) {
    return (dispatch) => {
      return dispatch({
        type: constants.EDIT_PROPERTY_RATING,
        payload: rating,
      });
    };
  },
  editPropertyReview(review) {
    return (dispatch) => {
      return dispatch({
        type: constants.EDIT_PROPERTY_REVIEW,
        payload: review,
      });
    };
  },
  editManagerRating(rating) {
    return (dispatch) => {
      return dispatch({
        type: constants.EDIT_MANAGER_RATING,
        payload: rating,
      });
    };
  },
  editPropertyManagerReview(review) {
    return (dispatch) => {
      return dispatch({
        type: constants.EDIT_MANAGER_REVIEW,
        payload: review,
      });
    };
  },
  editTenantType(type) {
    return (dispatch) => {
      return dispatch({
        type: constants.EDIT_TENANT_TYPE,
        payload: type,
      });
    };
  },
};

export default RatingAndReviewActions;
